// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"038189f1","368":"bb76c0b5","894":"94d81bfd"}[chunkId] + ".chunk.js";
};